import { useEffect, useRef, useState } from "react";

const SearchableDropdown = ({
  options,
  selectedVal,
  handleChange,
  onSelect,
  placeholder,
  searchValue,
  setSearchValue,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  // const selectOption = (option) => {
  //   const value = option?.code
  //     ? `[${option.code}] ${option.name}`
  //     : option?.name;
  //   setSearchValue(value);
  //   onSelect(option);
  //   setIsOpen(false);
  // };
  const handleSelect = (option) => {
    const value = option?.code
      ? `[${option.code}] ${option.name}`
      : option?.name;
    setSelectedOption(value);
    setSearchValue(value);
    onSelect(option);
    setIsOpen(false);
    if (setSearchValue) setSearchValue("");
  };
  console.log(selectedOption, "selectedOption....");

  return (
    <div className="relative min-w-[140px]" ref={inputRef}>
      <div
        className="cursor-pointer rounded-md border border-gray-300 bg-white py-1 px-2"
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedOption ? selectedOption : placeholder}
      </div>

      {isOpen && (
        // <div className="absolute mt-1 w-full bg-[#fff] border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto z-10">
        //   {options?.length > 0 ? (
        //     options.map((option, index) => (
        //       <div
        //         key={option?.id || index}
        //         className="px-4 py-2 text-sm text-black cursor-pointer hover:bg-blue-100"
        //         onClick={() => selectOption(option)}
        //       >
        //         {option.code ? `[${option.code}] ` : ""}
        //         {option.name}
        //       </div>
        //     ))
        //   ) : (
        //     <div className="px-4 py-2 text-sm text-gray-500">
        //       No results found
        //     </div>
        //   )}
        // </div>
        <div className="absolute z-2 mt-2 w-full overflow-y-auto  border border-gray-300 bg-[#fff] shadow-lg">
          <ul className="max-h-40 p-2">
            <div className="relative w-full">
              <input
                type="text"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                placeholder="Search"
                className="w-full rounded border border-gray-300 p-1  focus:outline-none"
              />
            </div>
            {options?.length > 0 ? (
              options?.map((option) => (
                <>
                  <li
                    key={option.id}
                    className="cursor-pointer p-2 hover:bg-gray-200"
                    onClick={() => handleSelect(option)}
                  >
                    {option.code ? `[${option.code}] ` : ""}
                    {option.name}
                  </li>
                  <div className="border-b-[0.5px] border-gray-100"></div>
                </>
              ))
            ) : (
              <li className="p-2 text-gray-500">No results found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchableDropdown;
